// extracted by mini-css-extract-plugin
export var copyright = "index-module--copyright--DLTPC";
export var footer = "index-module--footer--uojx8";
export var noPadding = "index-module--noPadding--HBBuG";
export var socialLink = "index-module--socialLink--d1HrQ";
export var socials = "index-module--socials--BXgcc";
export var year = "index-module--year--+VHGk";